import utils from "axios/lib/utils"

/**
 * @param axios axios实例
 * @param config 自定义配置对象，可覆盖掉默认的自定义配置
 */
export default (axios, config = {abc: "abc"}) => {
    // console.debug(axios.defaults);
    const defaultConfig = {
        baseURL: process.env.NODE_ENV === 'development' ? "http://127.0.0.1:8080" :
            "https://server.hot-sea.com",//process.env.VUE_APP_BASEURL,
        timeout: 6 * 60 * 1000,
        // withCredentials: true,
        /*headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'custom-defined-header-key': 'custom-defined-header-value',
            // 自定义请求头：对所有请求方法生效
            common: {
                'common-defined-key-b': 'custom value: for all methods'
            },
            // 自定义请求头：只对post方法生效
            post: {
                'post-custom-key': 'custom value: only for post method'
            },
            // 自定义请求头：只对get方法生效
            get: {
                'get-custom-key': 'custom value: only for get method'
            }
        }*/
    }



    // Object.assign(axios.defaults, defaultConfig, config);
    axios.defaults = utils.merge(axios.defaults, defaultConfig, config);

    console.debug("出来啦: ",axios.defaults);
    return axios
}